
import { NavLink, useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { ILoginState } from '@share/store/slices';

import logoDark from '@assets/images/logo/LOGO-4-DARK.svg';
import { isLoginFromPath } from '@share/utils';

interface IMapStateToProps {
  loginStore: ILoginState;
}

const Navbar = () => {
  const login = useSelector((state: IMapStateToProps) => state.loginStore);

  const loginStore = useSelector((state: { loginStore: ILoginState }) => state.loginStore);

  const history = useHistory();

  const userStorage = loginStore.user;
  const isLogged = !!userStorage;
  const isLogin = isLoginFromPath(history);

  return (
    <header className="navbar navbar-expand-lg navbar-light bg-light sticky-top">
      <div className="container">
        <NavLink to={`/${login.account?.name}${isLogged ? '/dashboard' : ''}`} className="navbar-brand">
          <img src={logoDark} alt="Company Logo" className="navbar-brand-item" />
        </NavLink>
        <div className="d-flex">
          {!isLogin && (
            <NavLink to={`/${login.account?.name}/log-in`} className="btn btn-outline-secondary me-2">
              Log In
            </NavLink>)}
        </div>
      </div>
    </header>
  );
};

export default Navbar;
